<dc-navbar-default
  [useOnlyDarkLogo]="true"
  [position]="'right'"
></dc-navbar-default>

<main class="position-relative overflow-hidden">
  <dc-app-landing2-heading></dc-app-landing2-heading>

  <dc-slider-icons></dc-slider-icons>
  <dc-app-landing2-trending-design></dc-app-landing2-trending-design>
  <dc-app-landing2-focus-on-success></dc-app-landing2-focus-on-success>
  <dc-app-landing2-safety></dc-app-landing2-safety>
  <dc-counter1 [container-padding-bottom]="9"></dc-counter1>
  <dc-app-landing2-features></dc-app-landing2-features>
  <dc-app-landing2-popping-highlight></dc-app-landing2-popping-highlight>
  <dc-faqs1></dc-faqs1>
  <dc-app-landing2-download></dc-app-landing2-download>
  <dc-cta1></dc-cta1>

  <dc-footer1></dc-footer1>
</main>
